import { endPointsWatermarks } from './_watermark';

function getExistingOssImageOperations(url: string) {
  const match = url.match(/[?&]x-oss-process=image\/([^&#]+)/);
  if (!match) {
    return null;
  }
  return match[1].split('/');
}

function setOssImageProcess(url: string, operations: string[]) {
  const processValue = `image/${operations.join('/')}`;
  if (/[?&]x-oss-process=image\//.test(url)) {
    return url.replace(/([?&])x-oss-process=image\/[^&#]*/, `$1x-oss-process=${processValue}`);
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}x-oss-process=${processValue}`;
}

export function ossUrl({
  url,
  width,
  after = '',
  watermark = false,
  fill = false,
  originWidth,
  originHeight,
}: {
  url: string;
  after?: string;
  watermark?: boolean;
  width?: number;
  fill?: boolean;
  originWidth?: number;
  originHeight?: number;
}) {
  if (!url) {
    return;
  }

  if (url.endsWith('.svg')) {
    return url;
  }
  const afterStr = after ? ' ' + after : '';
  const operations: string[] = [];

  if (watermark) {
    operations.push(
      `watermark,image_${
        fill
          ? `${getFillWatermark(originWidth, originHeight)},fill_1`
          : 'cHVibGljL3dhdGVybWFyay5wbmc=,x_8,y_8'
      }`
    );
  }
  if (width) {
    operations.push(`resize,w_${~~width},m_lfit`);
  }

  if (!operations.length && !after) {
    return url;
  }

  const existingOperations = getExistingOssImageOperations(url);
  const nextUrl = setOssImageProcess(
    url,
    existingOperations ? [...existingOperations, ...operations] : operations
  );

  return nextUrl + afterStr;
}

function getFillWatermark(w?, h?) {
  const longSize = !w || !h ? 1000 : Math.max(w, h);
  const target = endPointsWatermarks.find(({ range }) => {
    return longSize >= range[0] && longSize <= range[1];
  })!;
  return target?.key || 'cHVibGljL2ZpbGwtd2F0ZXJtYXJrLnBuZw==';
}

export function onImageError(event, cb?: (ops) => void) {
  const imgElement = event.target;

  // 取消 img 元素的 onerror 属性，阻止后续错误触发此函数
  imgElement.onerror = null;
  fetch(imgElement.src)
    .then(async (res) => {
      if (res.status === 404) {
        imgElement.src =
          'https://static.lingvisions.com/public/641c6bd3142b44aa86d87ad0f5938c5b.svg';
        imgElement.style = 'object-fit: none!important';
        cb?.({
          isDeleted: true,
        });
      } else if (res.status === 403 && (await res.text()).includes('InvalidObjectState')) {
        imgElement.src =
          'https://static.lingvisions.com/public/641c6bd3142b44aa86d87ad0f5938c5b.svg';
        imgElement.style = 'object-fit: none!important';
        cb?.({
          isDeleted: true,
        });
      } else {
        cb?.({
          isDeleted: false,
        });
      }
    })
    .catch((err) => {
      console.error(err);
      cb?.({
        isDeleted: false,
      });
    });
}
